const WHATSAPP = 'https://wa.me/917306725502';

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with GlobeSync Travel on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-accent-500 text-background-50 shadow-lg transition-transform hover:scale-105 md:bottom-6 md:right-6"
    >
      <i className="ri-whatsapp-line text-2xl" />
    </a>
  );
}